import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../http";
import { getApiErrorMessage, toApiError } from "../utils";

interface UpdateRequestProductStatusDTO {
    id: string;
    status: "PENDING" | "APPROVED" | "REJECTED";
}

export const useUpdateRequestProductStatus = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ id, status }: UpdateRequestProductStatusDTO) => {
            try {
                const { data } = await api.patch(`/request-products/updateStatus/${id}`, { status });
                return data;
            } catch (error) {
                throw toApiError(error, 'Erro ao atualizar status da requisição de produto');
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['request-products'] });
        },
        onError: (error) => {
            console.error('Erro ao atualizar status da requisição de produto:', getApiErrorMessage(error, 'Erro ao atualizar status da requisição de produto'))
        },
    });
};
